/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Grid, Segment, Divider, Form, Accordion,
  Checkbox, Pagination, Icon, Dropdown
} from "semantic-ui-react";
import Chart from "react-apexcharts";
import ApexChart from "apexcharts";
import Constants from "./utilities/Constants";
import Strings from "./utilities/StringSelector";
import Utils from "./utilities/Utils";

const UtilsInstance = new Utils();

const dropdownOptions = [
  {
    key: "amplitude",
    text: Strings.AMPLITUDE,
    value: "amplitude"
  },
  {
    key: "noise",
    text: Strings.NOISE,
    value: "noise"
  },
  {
    key: "jitter",
    text: Strings.JITTER,
    value: "jitter"
  },
  {
    key: "unbalance",
    text: Strings.UNBALANCE,
    value: "unbalance"
  }
];

class BarGraph extends Component {

  constructor(props) {
    super(props);

    this.state = {
      graphType: "",
      activeChart: "",

      isDropdownDisabled: true,

      isActualCheckboxDisabled: true,
      isMinCheckboxDisabled: true,
      isMaxCheckboxDisabled: true,

      isaddrAscCheckboxDisabled: true,
      isVoltAscCheckboxDisabled: true,
      isVoltDescCheckboxDisabled: true,

      minCheckboxLabel: Strings.MINIMUM_FEM,
      maxCheckboxLabel: Strings.MAXIMUM_FEM,

      ascCheckboxLabel: Strings.AMPLITUDE_ASC,
      descCheckboxLabel: Strings.AMPLITUDE_DESC,

      isActualCheckboxChecked: true,
      isMinCheckboxChecked: false,
      isMaxCheckboxChecked: false,

      isAddrCheckboxActive: true,
      isDescCheckboxActive: false,
      isAscCheckboxActive: false,

      amplitudeSeries: [],
      minAmplitudeSeries: [],

      activePage: 1,
      numOfPages: 1,

      // These maps are used to divide the device's list into
      // pages. The keys are 0 to n, and each key represents a page
      //  ------------------------ Amplitude ------------------------
      ascAddrcAmplitudePageMap: new Map(),     // Ordered by address ascending
      ascAmplitudePageMap: new Map(),          // Ordered by amplitude ascending
      descAmplitudePageMap: new Map(),         // Ordered by amplitude descending

      ascAddrcMinAmplitudePageMap: new Map(),  // Ordered by address ascending
      ascMinAmplitudePageMap: new Map(),       // Ordered by min amplitude ascending        
      descMinAmplitudePageMap: new Map(),      // Ordered by min amplitude descending

      ascAddrcMaxAmplitudePageMap: new Map(),  // Ordered by address ascending
      ascMaxAmplitudePageMap: new Map(),       // Ordered by max amplitude ascending        
      descMaxAmplitudePageMap: new Map(),      // Ordered by max amplitude descending

      //  ------------------------ Noise ------------------------
      ascAddrcNoisePageMap: new Map(),       // Ordered by address ascending
      ascNoisePageMap: new Map(),            // Ordered by noise ascending
      descNoisePageMap: new Map(),           // Ordered by noise descending

      ascAddrcMinNoisePageMap: new Map(),    // Ordered by address ascending
      ascMinNoisePageMap: new Map(),         // Ordered by min noise ascending        
      descMinNoisePageMap: new Map(),        // Ordered by min noise descending

      ascAddrcMaxNoisePageMap: new Map(),    // Ordered by address ascending
      ascMaxNoisePageMap: new Map(),         // Ordered by max noise ascending        
      descMaxNoisePageMap: new Map(),        // Ordered by max noise descending

      //  ------------------------ Jitter ------------------------
      ascAddrcJitterPageMap: new Map(),       // Ordered by address ascending
      ascJitterPageMap: new Map(),            // Ordered by jitter ascending
      descJitterPageMap: new Map(),           // Ordered by jitter descending

      ascAddrcMinJitterPageMap: new Map(),    // Ordered by address ascending
      ascMinJitterPageMap: new Map(),         // Ordered by min jitter ascending        
      descMinJitterPageMap: new Map(),        // Ordered by min jitter descending

      ascAddrcMaxJitterPageMap: new Map(),    // Ordered by address ascending
      ascMaxJitterPageMap: new Map(),         // Ordered by max jitter ascending        
      descMaxJitterPageMap: new Map(),        // Ordered by max jitter descending

      //  ------------------------ Unbalance ------------------------
      ascAddrcUnbalancePageMap: new Map(),    // Ordered by address ascending
      ascUnbalancePageMap: new Map(),         // Ordered by Unbalance ascending
      descUnbalancePageMap: new Map(),        // Ordered by Unbalance descending

      options: {
        tooltip: {
          enabled: false,
          x: {
            show: true,
            formatter: function (val) {
              return Strings.ADDRESS + ": " + val;
            },
          },
          marker: {
            show: false,
          },
        },
        chart: {
          id: Constants.BAR_GRAPH_CHART_ID,
          animations: {
            enabled: false
          },
          toolbar: {
            show: false
          },
          locales: [{
            "name": "pt-br",
            "options": {
              "toolbar": {
                "exportToSVG": "Baixar SVG",
                "exportToPNG": "Baixar PNG",
                "exportToCSV": "Baixar CSV",
                "menu": "Baixar"
              }
            }
          }],
          defaultLocale: "pt-br",
        },
        title: {
          text: Strings.AMPLITUDE,
          align: "center"
        },
        xaxis: {
          type: "category",
          title: {
            text: Strings.ADDRESS
          },
          crosshairs: {
            show: "true"
          }
        },
        yaxis: {
          min: 0,
          max: 2200,
          labels: {
            formatter: function (val) {
              return val.toFixed(0) + " " + Strings.MILLIVOLT;
            },
          },
          title: {
            text: Strings.VOLTAGE_MV
          },
        },
        colors: [function ({ value }) {
          return (UtilsInstance.getPABarGraphColorBasedOnValue(value, Constants, null, null));
        }],
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top",
            }
          }
        },
        dataLabels: {
          formatter: function (val) {
            if (val < 0) {
              // Don't show the number above a bar with
              // negative values
              return "";
            }
            else if (val === 0) {
              return "0,00";
            }
            else {
              return val;
            }
          },
          style: {
            fontSize: "14px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 400,
            colors: ["#212121"],
          },
          offsetY: -22,
        },
      },
      errorMessages: [],
      accordionIndex: -1,
      jitterAccordionIndex: -1,
    };
  }

  retrieveData = async () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "liveList/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ devices: this.convertAmplitudeValuesTomV(data) }, () => {
        // Set the state of the number of pages, it will be used for everything else
        this.setState({ numOfPages: Math.ceil(this.state.devices.length / Constants.MAX_DEV_PER_PAGE) }, () => {
          // Save the mappings
          this.setState({
            ascAddrcAmplitudePageMap: this.createAscAddrAmpPageMap(),
            ascAmplitudePageMap: this.createAscAmpPageMap(),
            descAmplitudePageMap: this.createDescAmpPageMap(),

            ascAddrcMinAmplitudePageMap: this.createAscAddrMinAmpPageMap(),
            ascMinAmplitudePageMap: this.createAscMinAmpPageMap(),
            descMinAmplitudePageMap: this.createDescMinAmpPageMap(),

            ascAddrcNoisePageMap: this.createAscAddrNoisePageMap(),
            ascNoisePageMap: this.createAscNoisePageMap(),
            descNoisePageMap: this.createDescNoisePageMap(),

            ascAddrcMinNoisePageMap: this.createAscAddrMinNoisePageMap(),
            ascMinNoisePageMap: this.createAscMinNoisePageMap(),
            descMinNoisePageMap: this.createDescMinNoisePageMap(),

            ascAddrcMaxNoisePageMap: this.createAscAddrMaxNoisePageMap(),
            ascMaxNoisePageMap: this.createAscMaxNoisePageMap(),
            descMaxNoisePageMap: this.createDescMaxNoisePageMap(),

            ascAddrcJitterPageMap: this.createAscAddrJitterPageMap(),
            ascJitterPageMap: this.createAscJitterPageMap(),
            descJitterPageMap: this.createDescJitterPageMap(),

            ascAddrcMinJitterPageMap: this.createAscAddrMinJitterPageMap(),
            ascMinJitterPageMap: this.createAscMinJitterPageMap(),
            descMinJitterPageMap: this.createDescMinJitterPageMap(),

            ascAddrcMaxJitterPageMap: this.createAscAddrMaxJitterPageMap(),
            ascMaxJitterPageMap: this.createAscMaxJitterPageMap(),
            descMaxJitterPageMap: this.createDescMaxJitterPageMap(),

            ascAddrcUnbalancePageMap: this.createAscAddrUnbalancePageMap(),
            ascUnbalancePageMap: this.createAscUnbalancePageMap(),
            descUnbalancePageMap: this.createDescUnbalancePageMap(),

            isDropdownDisabled: false
          }, () => {
            if (this.state.graphType === "amplitude") {
              this.showAmplitudeGraph(this.state.devices);
            }
            else if (this.state.graphType === "noise") {
              this.showNoiseGraph(this.state.devices);
            }
            else if (this.state.graphType === "jitter") {
              this.showJitterGraph(this.state.devices);
            }
            else if (this.state.graphType === "unbalance") {
              this.showUnbalanceGraph(this.state.devices);
            }
          });
        });
      }));
  }

  convertAmplitudeValuesTomV = (data) => {
    for (let i = 0; i < data.length; i++) {

      data[i].amplitude = data[i].amplitude * 1000;
      data[i].amplitudeMin = data[i].amplitudeMin * 1000;

      data[i].noise = data[i].noise * 1000;
      data[i].noiseMax = data[i].noiseMax * 1000;
      data[i].noiseMin = data[i].noiseMin * 1000;

      data[i].absUnbalance = data[i].absUnbalance * 100;
    }

    return data;
  }

  showAmplitudeGraph = (devices) => {
    // Show the pagination
    document.getElementById("pagination").style.visibility = "visible";

    if (document.getElementById("jitter-accordion") !== undefined
      && document.getElementById("jitter-accordion") !== null) {
      document.getElementById("jitter-accordion").style.display = "none";
    }

    if (this.state.isActualCheckboxChecked) {

      if (this.state.isAddrCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.AMPLITUDE,
          data: this.state.ascAddrcAmplitudePageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isAscCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.AMPLITUDE,
          data: this.state.ascAmplitudePageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isDescCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.AMPLITUDE,
          data: this.state.descAmplitudePageMap.get(this.state.activePage - 1)
        }]);
      }

      // Change the title of the chart
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
        title: {
          text: Strings.AMPLITUDE,
          align: "center"
        },
        yaxis: {
          min: 0,
          max: 2200,
          labels: {
            formatter: function (val) {
              return val.toFixed(0) + " " + Strings.MILLIVOLT;
            },
          },
          title: {
            text: Strings.VOLTAGE_MV
          },
        },
        colors: [function ({ seriesIndex, dataPointIndex, w }) {
          const point = w.config.series[seriesIndex].data[dataPointIndex];
          const status = point.status;
          const hasWaveProblem = point.hasWaveProblem;
          return (UtilsInstance.getPABarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
        }],
      });

      // And save that this is the active chart now
      this.setState({ activeChart: Constants.AMPLITUDE_ID });

    }
    else if (this.state.isMinCheckboxChecked) {

      if (this.state.isAddrCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.MIN_AMPLITUDE,
          data: this.state.ascAddrcMinAmplitudePageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isAscCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.MIN_AMPLITUDE,
          data: this.state.ascMinAmplitudePageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isDescCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.MIN_AMPLITUDE,
          data: this.state.descMinAmplitudePageMap.get(this.state.activePage - 1)
        }]);
      }

      // Change the title of the chart
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
        title: {
          text: Strings.MIN_AMPLITUDE,
          align: "center"
        },
        yaxis: {
          min: 0,
          max: 2200,
          labels: {
            formatter: function (val) {
              return val.toFixed(0) + " " + Strings.MILLIVOLT;
            },
          },
          title: {
            text: Strings.VOLTAGE_MV
          },
        },
        colors: [function ({ seriesIndex, dataPointIndex, w }) {
          const point = w.config.series[seriesIndex].data[dataPointIndex];
          const status = point.status;
          const hasWaveProblem = point.hasWaveProblem;
          return (UtilsInstance.getPABarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
        }],
      });

      // And save that this is the active chart now
      this.setState({ activeChart: Constants.MIN_AMPLITUDE_ID });

    }
  }

  showNoiseGraph = (devices) => {
    // Show the pagination
    document.getElementById("pagination").style.visibility = "visible";

    if (document.getElementById("jitter-accordion") !== undefined
      && document.getElementById("jitter-accordion") !== null) {
      document.getElementById("jitter-accordion").style.display = "none";
    }

    if (this.state.isActualCheckboxChecked) {

      if (this.state.isAddrCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.NOISE,
          data: this.state.ascAddrcNoisePageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isAscCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.NOISE,
          data: this.state.ascNoisePageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isDescCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.NOISE,
          data: this.state.descNoisePageMap.get(this.state.activePage - 1)
        }]);
      }

      // Change the title of the chart
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
        title: {
          text: Strings.NOISE,
          align: "center"
        },
        yaxis: {
          min: 0,
          max: Constants.NOISE_MAX_Y_AXIS,
          labels: {
            formatter: function (val) {
              return val.toFixed(0) + " " + Strings.MILLIVOLT;
            },
          },
          title: {
            text: Strings.VOLTAGE_MV
          },
        },
        colors: [function ({ seriesIndex, dataPointIndex, w }) {
          const point = w.config.series[seriesIndex].data[dataPointIndex];
          const status = point.status;
          const hasWaveProblem = point.hasWaveProblem;
          //console.log(point);
          return (UtilsInstance.getPANoiseBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
        }],
      });

      // And save that this is the active chart now
      this.setState({ activeChart: Constants.NOISE_ID });

    }
    else if (this.state.isMinCheckboxChecked) {

      if (this.state.isAddrCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.NOISE_MIN,
          data: this.state.ascAddrcMinNoisePageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isAscCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.NOISE_MIN,
          data: this.state.ascMinNoisePageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isDescCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.NOISE_MIN,
          data: this.state.descMinNoisePageMap.get(this.state.activePage - 1)
        }]);
      }

      // Change the title of the chart
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
        title: {
          text: Strings.NOISE_MIN,
          align: "center"
        },
        yaxis: {
          min: 0,
          max: Constants.NOISE_MAX_Y_AXIS,
          labels: {
            formatter: function (val) {
              return val.toFixed(0) + " " + Strings.MILLIVOLT;
            },
          },
          title: {
            text: Strings.VOLTAGE_MV
          },
        },
        colors: [function ({ seriesIndex, dataPointIndex, w }) {
          const point = w.config.series[seriesIndex].data[dataPointIndex];
          const status = point.status;
          const hasWaveProblem = point.hasWaveProblem;
          return (UtilsInstance.getPANoiseBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
        }],
      });

      // And save that this is the active chart now
      this.setState({ activeChart: Constants.MIN_NOISE_ID });

    }
    else if (this.state.isMaxCheckboxChecked) {

      if (this.state.isAddrCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.NOISE_MAX,
          data: this.state.ascAddrcMaxNoisePageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isAscCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.NOISE_MAX,
          data: this.state.ascMaxNoisePageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isDescCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.NOISE_MAX,
          data: this.state.descMaxNoisePageMap.get(this.state.activePage - 1)
        }]);
      }

      // Change the title of the chart
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
        title: {
          text: Strings.NOISE_MAX,
          align: "center"
        },
        yaxis: {
          min: 0,
          max: Constants.NOISE_MAX_Y_AXIS,
          labels: {
            formatter: function (val) {
              return val.toFixed(0) + " " + Strings.MILLIVOLT;
            },
          },
          title: {
            text: Strings.VOLTAGE_MV
          },
        },
        colors: [function ({ seriesIndex, dataPointIndex, w }) {
          const point = w.config.series[seriesIndex].data[dataPointIndex];
          const status = point.status;
          const hasWaveProblem = point.hasWaveProblem;
          return (UtilsInstance.getPANoiseBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
        }],
      });

      // And save that this is the active chart now
      this.setState({ activeChart: Constants.MAX_NOISE_ID });
    }
  }

  showJitterGraph = (devices) => {
    // Show the pagination
    document.getElementById("pagination").style.visibility = "visible";

    if (document.getElementById("jitter-accordion") !== undefined
      && document.getElementById("jitter-accordion") !== null) {
      document.getElementById("jitter-accordion").style.display = "block";
    }

    if (this.state.isActualCheckboxChecked) {

      if (this.state.isAddrCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.JITTER,
          data: this.state.ascAddrcJitterPageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isAscCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.JITTER,
          data: this.state.ascJitterPageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isDescCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.JITTER,
          data: this.state.descJitterPageMap.get(this.state.activePage - 1)
        }]);
      }

      // Change the title of the chart
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
        title: {
          text: Strings.JITTER,
          align: "center"
        },
        yaxis: {
          min: 0,
          max: Constants.JITTER_MAX_Y_AXIS,
          labels: {
            formatter: function (val) {
              return val.toFixed(2) + " " + Strings.MICROSSECOND;
            },
          },
          title: {
            text: Strings.MICROSSECOND_TITLE
          },
        },
        colors: [function ({ seriesIndex, dataPointIndex, w }) {
          const point = w.config.series[seriesIndex].data[dataPointIndex];
          const status = point.status;
          const hasWaveProblem = point.hasWaveProblem;
          return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
        }],
      });

      // And save that this is the active chart now
      this.setState({ activeChart: Constants.JITTER_ID });

    }
    else if (this.state.isMinCheckboxChecked) {

      if (this.state.isAddrCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.JITTER_MIN,
          data: this.state.ascAddrcMinJitterPageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isAscCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.JITTER_MIN,
          data: this.state.ascMinJitterPageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isDescCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.JITTER_MIN,
          data: this.state.descMinJitterPageMap.get(this.state.activePage - 1)
        }]);
      }

      // Change the title of the chart
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
        title: {
          text: Strings.JITTER_MIN,
          align: "center"
        },
        yaxis: {
          min: 0,
          max: Constants.JITTER_MAX_Y_AXIS,
          labels: {
            formatter: function (val) {
              return val.toFixed(2) + " " + Strings.MICROSSECOND;
            },
          },
          title: {
            text: Strings.MICROSSECOND_TITLE
          },
        },
        colors: [function ({ seriesIndex, dataPointIndex, w }) {
          const point = w.config.series[seriesIndex].data[dataPointIndex];
          const status = point.status;
          const hasWaveProblem = point.hasWaveProblem;
          //console.log(point);
          return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
        }],
      });

      // And save that this is the active chart now
      this.setState({ activeChart: Constants.MIN_JITTER_ID });

    }
    else if (this.state.isMaxCheckboxChecked) {

      if (this.state.isAddrCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.JITTER_MAX,
          data: this.state.ascAddrcMaxJitterPageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isAscCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.JITTER_MAX,
          data: this.state.ascMaxJitterPageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isDescCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.JITTER_MAX,
          data: this.state.descMaxJitterPageMap.get(this.state.activePage - 1)
        }]);
      }

      // Change the title of the chart
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
        title: {
          text: Strings.JITTER_MAX,
          align: "center"
        },
        yaxis: {
          min: 0,
          max: Constants.JITTER_MAX_Y_AXIS,
          labels: {
            formatter: function (val) {
              return val.toFixed(2) + " " + Strings.MICROSSECOND;
            },
          },
          title: {
            text: Strings.MICROSSECOND_TITLE
          },
        },
        colors: [function ({ seriesIndex, dataPointIndex, w }) {
          const point = w.config.series[seriesIndex].data[dataPointIndex];
          const status = point.status;
          const hasWaveProblem = point.hasWaveProblem;
          //console.log(point);
          return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
        }],
      });

      // And save that this is the active chart now
      this.setState({ activeChart: Constants.MAX_JITTER_ID });
    }
  }

  showUnbalanceGraph = (devices) => {
    // Show the pagination
    document.getElementById("pagination").style.visibility = "visible";

    if (document.getElementById("jitter-accordion") !== undefined
      && document.getElementById("jitter-accordion") !== null) {
      document.getElementById("jitter-accordion").style.display = "none";
    }

    if (this.state.isActualCheckboxChecked) {

      if (this.state.isAddrCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.UNBALANCE,
          data: this.state.ascAddrcUnbalancePageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isAscCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.UNBALANCE,
          data: this.state.ascUnbalancePageMap.get(this.state.activePage - 1)
        }]);
      }
      else if (this.state.isDescCheckboxActive) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.UNBALANCE,
          data: this.state.descUnbalancePageMap.get(this.state.activePage - 1)
        }]);
      }

      // Change the title of the chart
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
        title: {
          text: Strings.UNBALANCE,
          align: "center"
        },
        yaxis: {
          min: 0,
          max: Constants.UNBALANCE_MAX_Y_AXIS,
          labels: {
            formatter: function (val) {
              return val.toFixed(2) + " " + Strings.PORCENTAGEM;
            },
          },
          title: {
            text: Strings.UNBALANCE_PORCENT
          },
        },
        colors: [function ({ seriesIndex, dataPointIndex, w }) {
          const point = w.config.series[seriesIndex].data[dataPointIndex];
          const status = point.status;
          const hasWaveProblem = point.hasWaveProblem;
          //console.log(point);
          return (UtilsInstance.getPAUnbalanceBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
        }],
      });

      // And save that this is the active chart now
      this.setState({ activeChart: Constants.UNBALANCE_ID });

    }
  }

  /// ---------------- Mappings ----------------

  /// ---------------- AMPLITUDE ----------------

  // Ordered by device address ascending
  createAscAddrAmpPageMap = () => {
    let ascAddrAmpMap = new Map();

    let ascAddrSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "address",
        false,
        parseInt)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      //console.log(ascAddrSortedDevices);

      //console.log(ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length));

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length);
      }
      else {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let ampPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        ampPageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedAmplitudeForFaded(
            parseFloat(devicesSlice[j].amplitude.toFixed(0)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].status,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - ampPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            ampPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascAddrAmpMap.set(i, ampPageSeries);
    }

    // And save that this is the active chart now
    this.setState({ activeChart: Constants.AMPLITUDE_ID });

    return ascAddrAmpMap;
  }

  createAscAddrMinAmpPageMap = () => {
    let ascAddrMinAmpMap = new Map();

    let ascAddrSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "address",
        false,
        parseInt)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length);
      }
      else {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let minAmpPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        minAmpPageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedAmplitudeForFaded(
            parseFloat(devicesSlice[j].amplitudeMin.toFixed(0)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].status,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - minAmpPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            minAmpPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascAddrMinAmpMap.set(i, minAmpPageSeries);
    }

    return ascAddrMinAmpMap;
  }

  // Ordered by amplitude value ascending
  createAscAmpPageMap = () => {
    let ascAmpMap = new Map();

    let ascAmpSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "amplitude",
        false,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAmpSortedDevices.length);
      }
      else {
        devicesSlice = ascAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let ampPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        ampPageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedAmplitudeForFaded(
            parseFloat(devicesSlice[j].amplitude.toFixed(0)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].status,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - ampPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            ampPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascAmpMap.set(i, ampPageSeries);
    }

    return ascAmpMap;
  }

  createAscMinAmpPageMap = () => {
    let ascMinAmpMap = new Map();

    let ascMinAmpSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "amplitudeMin",
        false,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascMinAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascMinAmpSortedDevices.length);
      }
      else {
        devicesSlice = ascMinAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let minAmpPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        minAmpPageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedAmplitudeForFaded(
            parseFloat(devicesSlice[j].amplitudeMin.toFixed(0)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].status,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - minAmpPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            minAmpPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascMinAmpMap.set(i, minAmpPageSeries);
    }

    return ascMinAmpMap;
  }

  // Ordered by amplitude value descending
  createDescAmpPageMap = () => {
    let descAmpMap = new Map();

    let descAmpSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "amplitude",
        true,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = descAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, descAmpSortedDevices.length);
      }
      else {
        devicesSlice = descAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let ampPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        ampPageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedAmplitudeForFaded(
            parseFloat(devicesSlice[j].amplitude.toFixed(0)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].status,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - ampPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            ampPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      descAmpMap.set(i, ampPageSeries);
    }

    return descAmpMap;
  }

  createDescMinAmpPageMap = () => {
    let descMinAmpMap = new Map();

    let descMinAmpSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "amplitudeMin",
        true,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = descMinAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, descMinAmpSortedDevices.length);
      }
      else {
        devicesSlice = descMinAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let minAmpPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        minAmpPageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedAmplitudeForFaded(
            parseFloat(devicesSlice[j].amplitudeMin.toFixed(0)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].status,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - minAmpPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            minAmpPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      descMinAmpMap.set(i, minAmpPageSeries);
    }

    return descMinAmpMap;
  }

  /// ---------------- NOISE ----------------
  // Ordered by device address ascending
  createAscAddrNoisePageMap = () => {
    let ascAddrNoiseMap = new Map();

    let ascAddrSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "address",
        false,
        parseInt)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length);
      }
      else {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let noisePageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        noisePageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedNoiseForFaded(
            parseFloat(devicesSlice[j].noise.toFixed(0)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusNoise,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - noisePageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            noisePageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascAddrNoiseMap.set(i, noisePageSeries);
    }

    return ascAddrNoiseMap;
  }

  createAscAddrMinNoisePageMap = () => {
    let ascAddrMinNoiseMap = new Map();

    let ascAddrSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "address",
        false,
        parseInt)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length);
      }
      else {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let minNoisePageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        minNoisePageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedNoiseForFaded(
            parseFloat(devicesSlice[j].noiseMin.toFixed(0)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusNoiseMin,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - minNoisePageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            minNoisePageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascAddrMinNoiseMap.set(i, minNoisePageSeries);
    }

    return ascAddrMinNoiseMap;
  }

  createAscAddrMaxNoisePageMap = () => {
    let ascAddrMaxNoiseMap = new Map();

    let ascAddrSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "address",
        false,
        parseInt)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length);
      }
      else {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let maxNoisePageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        maxNoisePageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedNoiseForFaded(
            parseFloat(devicesSlice[j].noiseMax.toFixed(0)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusNoiseMax,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - maxNoisePageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            maxNoisePageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascAddrMaxNoiseMap.set(i, maxNoisePageSeries);
    }

    return ascAddrMaxNoiseMap;
  }

  // Ordered by noise ascending
  createAscNoisePageMap = () => {
    let ascNoiseMap = new Map();

    let ascNoiseSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "noise",
        false,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascNoiseSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascNoiseSortedDevices.length);
      }
      else {
        devicesSlice = ascNoiseSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let noisePageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        noisePageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedNoiseForFaded(
            parseFloat(devicesSlice[j].noise.toFixed(0)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusNoise,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - noisePageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            noisePageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascNoiseMap.set(i, noisePageSeries);
    }

    return ascNoiseMap;
  }

  createAscMinNoisePageMap = () => {
    let ascMinNoiseMap = new Map();

    let ascMinNoiseSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "noiseMin",
        false,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascMinNoiseSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascMinNoiseSortedDevices.length);
      }
      else {
        devicesSlice = ascMinNoiseSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let minNoisePageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        minNoisePageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedNoiseForFaded(
            parseFloat(devicesSlice[j].noiseMin.toFixed(0)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusNoiseMin,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - minNoisePageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            minNoisePageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascMinNoiseMap.set(i, minNoisePageSeries);
    }

    return ascMinNoiseMap;
  }

  createAscMaxNoisePageMap = () => {
    let ascMaxNoiseMap = new Map();

    let ascMaxNoiseSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "noiseMax",
        false,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascMaxNoiseSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascMaxNoiseSortedDevices.length);
      }
      else {
        devicesSlice = ascMaxNoiseSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let maxNoisePageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        maxNoisePageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedNoiseForFaded(
            parseFloat(devicesSlice[j].noiseMax.toFixed(0)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusNoiseMax,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - maxNoisePageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            maxNoisePageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascMaxNoiseMap.set(i, maxNoisePageSeries);
    }

    return ascMaxNoiseMap;
  }

  // Ordered by noise value descending
  createDescNoisePageMap = () => {
    let descNoiseMap = new Map();

    let descNoiseSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "noise",
        true,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = descNoiseSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, descNoiseSortedDevices.length);
      }
      else {
        devicesSlice = descNoiseSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let noisePageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        noisePageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedNoiseForFaded(
            parseFloat(devicesSlice[j].noise.toFixed(0)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusNoise,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - noisePageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            noisePageSeries.push({ x: "", y: -1 });
          }
        }

      }

      descNoiseMap.set(i, noisePageSeries);
    }

    return descNoiseMap;
  }

  createDescMinNoisePageMap = () => {
    let descMinNoiseMap = new Map();

    let descMinNoiseSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "noiseMin",
        true,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = descMinNoiseSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, descMinNoiseSortedDevices.length);
      }
      else {
        devicesSlice = descMinNoiseSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let minNoisePageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        minNoisePageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedNoiseForFaded(
            parseFloat(devicesSlice[j].noiseMin.toFixed(0)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusNoiseMin,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - minNoisePageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            minNoisePageSeries.push({ x: "", y: -1 });
          }
        }

      }

      descMinNoiseMap.set(i, minNoisePageSeries);
    }

    return descMinNoiseMap;
  }

  createDescMaxNoisePageMap = () => {
    let descMaxNoiseMap = new Map();

    let descMaxNoiseSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "noiseMax",
        true,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = descMaxNoiseSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, descMaxNoiseSortedDevices.length);
      }
      else {
        devicesSlice = descMaxNoiseSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let maxNoisePageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        maxNoisePageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedNoiseForFaded(
            parseFloat(devicesSlice[j].noiseMax.toFixed(0)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusNoiseMax,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - maxNoisePageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            maxNoisePageSeries.push({ x: "", y: -1 });
          }
        }

      }

      descMaxNoiseMap.set(i, maxNoisePageSeries);
    }

    return descMaxNoiseMap;
  }

  /// ---------------- Jitter ----------------

  // Ordered by device address ascending
  createAscAddrJitterPageMap = () => {
    let ascAddrJitterMap = new Map();

    let ascAddrSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "address",
        false,
        parseInt)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length);
      }
      else {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let jitterPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        jitterPageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedJitterForFaded(
            parseFloat(devicesSlice[j].jitter.toFixed(2)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusJitter,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - jitterPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            jitterPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascAddrJitterMap.set(i, jitterPageSeries);
    }

    return ascAddrJitterMap;
  }

  createAscAddrMinJitterPageMap = () => {
    let ascAddrMinJitterMap = new Map();

    let ascAddrSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "address",
        false,
        parseInt)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length);
      }
      else {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let minJitterPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        minJitterPageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedJitterForFaded(
            parseFloat(devicesSlice[j].jitterMin.toFixed(2)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusJitterMin,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - minJitterPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            minJitterPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascAddrMinJitterMap.set(i, minJitterPageSeries);
    }

    return ascAddrMinJitterMap;
  }

  createAscAddrMaxJitterPageMap = () => {
    let ascAddrMaxJitterMap = new Map();

    let ascAddrSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "address",
        false,
        parseInt)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length);
      }
      else {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let maxJitterPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        maxJitterPageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedJitterForFaded(
            parseFloat(devicesSlice[j].jitterMax.toFixed(2)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusJitterMax,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - maxJitterPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            maxJitterPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascAddrMaxJitterMap.set(i, maxJitterPageSeries);
    }

    return ascAddrMaxJitterMap;
  }

  // Ordered by Jitter value ascending
  createAscJitterPageMap = () => {
    let ascJitterMap = new Map();

    let ascJitterSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "jitter",
        false,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascJitterSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascJitterSortedDevices.length);
      }
      else {
        devicesSlice = ascJitterSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let jitterPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        jitterPageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedJitterForFaded(
            parseFloat(devicesSlice[j].jitter.toFixed(2)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusJitter,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - jitterPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            jitterPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascJitterMap.set(i, jitterPageSeries);
    }

    return ascJitterMap;
  }

  createAscMinJitterPageMap = () => {
    let ascMinJitterMap = new Map();

    let ascMinJitterSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "jitterMin",
        false,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascMinJitterSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascMinJitterSortedDevices.length);
      }
      else {
        devicesSlice = ascMinJitterSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let minJitterPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        minJitterPageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedJitterForFaded(
            parseFloat(devicesSlice[j].jitterMin.toFixed(2)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusJitterMin,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - minJitterPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            minJitterPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascMinJitterMap.set(i, minJitterPageSeries);
    }

    return ascMinJitterMap;
  }

  createAscMaxJitterPageMap = () => {
    let ascMaxJitterMap = new Map();

    let ascMaxJitterSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "jitterMax",
        false,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascMaxJitterSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascMaxJitterSortedDevices.length);
      }
      else {
        devicesSlice = ascMaxJitterSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let maxJitterPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        maxJitterPageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedJitterForFaded(
            parseFloat(devicesSlice[j].jitterMax.toFixed(2)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusJitterMax,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - maxJitterPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            maxJitterPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascMaxJitterMap.set(i, maxJitterPageSeries);
    }

    return ascMaxJitterMap;
  }

  // Ordered by Jitter value descending
  createDescJitterPageMap = () => {
    let descJitterMap = new Map();

    let descJitterSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "jitter",
        true,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = descJitterSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, descJitterSortedDevices.length);
      }
      else {
        devicesSlice = descJitterSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let jitterPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        jitterPageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedJitterForFaded(
            parseFloat(devicesSlice[j].jitter.toFixed(2)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusJitter,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - jitterPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            jitterPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      descJitterMap.set(i, jitterPageSeries);
    }

    return descJitterMap;
  }

  createDescMinJitterPageMap = () => {
    let descMinJitterMap = new Map();

    let descMinJitterSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "jitterMin",
        true,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = descMinJitterSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, descMinJitterSortedDevices.length);
      }
      else {
        devicesSlice = descMinJitterSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let minJitterPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        minJitterPageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedJitterForFaded(
            parseFloat(devicesSlice[j].jitterMin.toFixed(2)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusJitterMin,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - minJitterPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            minJitterPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      descMinJitterMap.set(i, minJitterPageSeries);
    }

    return descMinJitterMap;
  }

  createDescMaxJitterPageMap = () => {
    let descMaxJitterMap = new Map();

    let descMaxJitterSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "jitterMax",
        true,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = descMaxJitterSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, descMaxJitterSortedDevices.length);
      }
      else {
        devicesSlice = descMaxJitterSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let maxJitterPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        maxJitterPageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedJitterForFaded(
            parseFloat(devicesSlice[j].jitterMax.toFixed(2)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusJitterMax,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - maxJitterPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            maxJitterPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      descMaxJitterMap.set(i, maxJitterPageSeries);
    }

    return descMaxJitterMap;
  }

  /// ---------------- Unbalance ----------------

  // Ordered by device address ascending
  createAscAddrUnbalancePageMap = () => {
    let ascAddrUnbalanceMap = new Map();

    let ascAddrSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "address",
        false,
        parseInt)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length);
      }
      else {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let unbalancePageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        unbalancePageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedUnbalanceForFaded(
            parseFloat(devicesSlice[j].absUnbalance.toFixed(2)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusUnbalance,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - unbalancePageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            unbalancePageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascAddrUnbalanceMap.set(i, unbalancePageSeries);
    }

    return ascAddrUnbalanceMap;
  }

  // Ordered by unbalance value ascending
  createAscUnbalancePageMap = () => {
    let ascUnbalanceMap = new Map();

    let ascUnbalanceSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "absUnbalance",
        false,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascUnbalanceSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascUnbalanceSortedDevices.length);
      }
      else {
        devicesSlice = ascUnbalanceSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let unbalancePageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        unbalancePageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedUnbalanceForFaded(
            parseFloat(devicesSlice[j].absUnbalance.toFixed(2)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusUnbalance,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - unbalancePageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            unbalancePageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascUnbalanceMap.set(i, unbalancePageSeries);
    }

    return ascUnbalanceMap;
  }

  // Ordered by Unbalance value descending
  createDescUnbalancePageMap = () => {
    let descUnbalanceMap = new Map();

    let descUnbalanceSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "absUnbalance",
        true,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = descUnbalanceSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, descUnbalanceSortedDevices.length);
      }
      else {
        devicesSlice = descUnbalanceSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let unbalancePageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        unbalancePageSeries.push({
          x: devicesSlice[j].address.toString() + UtilsInstance.getMasterSuffix(devicesSlice[j].isMaster),
          y: UtilsInstance.getPAFormatedUnbalanceForFaded(
            parseFloat(devicesSlice[j].absUnbalance.toFixed(2)),
            devicesSlice[j].hasWaveProblem
          ),
          status: devicesSlice[j].statusUnbalance,
          hasWaveProblem: devicesSlice[j].hasWaveProblem
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - unbalancePageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            unbalancePageSeries.push({ x: "", y: -1 });
          }
        }

      }

      descUnbalanceMap.set(i, unbalancePageSeries);
    }

    return descUnbalanceMap;
  }

  // ---------------- Dropdown ----------------
  onDropdownChange = (e, { value }) => {
    if (value === "amplitude") {
      this.setState({
        graphType: value,
        minCheckboxLabel: Strings.MINIMUM_FEM,
        maxCheckboxLabel: Strings.MAXIMUM_FEM,
        ascCheckboxLabel: Strings.AMPLITUDE_ASC,
        descCheckboxLabel: Strings.AMPLITUDE_DESC,
        isActualCheckboxDisabled: false,
        isMinCheckboxDisabled: false,
        isMaxCheckboxDisabled: true,
        isaddrAscCheckboxDisabled: false,
        isVoltAscCheckboxDisabled: false,
        isVoltDescCheckboxDisabled: false
      }, () => {
        this.showAmplitudeGraph(this.state.devices);
      });
    }
    else if (value === "noise") {
      this.setState({
        graphType: value,
        minCheckboxLabel: Strings.MINIMUM_MASC,
        maxCheckboxLabel: Strings.MAXIMUM_MASC,
        ascCheckboxLabel: Strings.NOISE_ASC,
        descCheckboxLabel: Strings.NOISE_DESC,
        isActualCheckboxDisabled: false,
        isMinCheckboxDisabled: false,
        isMaxCheckboxDisabled: false,
        isaddrAscCheckboxDisabled: false,
        isVoltAscCheckboxDisabled: false,
        isVoltDescCheckboxDisabled: false
      }, () => {
        this.showNoiseGraph(this.state.devices);
      });
    }
    else if (value === "jitter") {
      this.setState({
        graphType: value,
        minCheckboxLabel: Strings.MINIMUM_MASC,
        maxCheckboxLabel: Strings.MAXIMUM_MASC,
        ascCheckboxLabel: Strings.JITTER_ASC,
        descCheckboxLabel: Strings.JITTER_DESC,
        isActualCheckboxDisabled: false,
        isMinCheckboxDisabled: false,
        isMaxCheckboxDisabled: false,
        isaddrAscCheckboxDisabled: false,
        isVoltAscCheckboxDisabled: false,
        isVoltDescCheckboxDisabled: false
      }, () => {
        this.showJitterGraph(this.state.devices);
      });
    }
    else if (value === "unbalance") {
      this.setState({
        graphType: value,
        minCheckboxLabel: Strings.MINIMUM_MASC,
        maxCheckboxLabel: Strings.MAXIMUM_MASC,
        ascCheckboxLabel: Strings.UNBALANCE_ASC,
        descCheckboxLabel: Strings.UNBALANCE_DESC,
        isActualCheckboxDisabled: false,
        isMinCheckboxDisabled: true,
        isMaxCheckboxDisabled: true,
        isaddrAscCheckboxDisabled: false,
        isVoltAscCheckboxDisabled: false,
        isVoltDescCheckboxDisabled: false
      }, () => {
        this.showUnbalanceGraph(this.state.devices);
      });
    }
  }

  /// ---------------- Graph Variation Options ----------------
  onGraphVariationCheckboxChange = (e, { value }) => {
    // Show the pagination
    document.getElementById("pagination").style.visibility = "visible";

    let devices = this.state.devices;

    if (this.state.graphType === "amplitude") {
      if (value === Constants.ACTUAL_ID) {
        this.setState({
          isActualCheckboxChecked: true,
          isMinCheckboxChecked: false,
          isMaxCheckboxChecked: false
        }, () => {

          if (this.state.isAddrCheckboxActive) {
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.AMPLITUDE,
              data: this.state.ascAddrcAmplitudePageMap.get(this.state.activePage - 1)
            }]);
          }
          else if (this.state.isAscCheckboxActive) {
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.AMPLITUDE,
              data: this.state.ascAmplitudePageMap.get(this.state.activePage - 1)
            }]);
          }
          else if (this.state.isDescCheckboxActive) {
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.AMPLITUDE,
              data: this.state.descAmplitudePageMap.get(this.state.activePage - 1)
            }]);
          }

          // Change the title of the chart
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            title: {
              text: Strings.AMPLITUDE,
              align: "center"
            },
            yaxis: {
              min: 0,
              max: 2200,
              labels: {
                formatter: function (val) {
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }],
          });
          // And save that this is the active chart now
          this.setState({ activeChart: Constants.AMPLITUDE_ID });

        });
      }
      else if (value === Constants.MIN_ID) {
        this.setState({
          isActualCheckboxChecked: false,
          isMinCheckboxChecked: true,
          isMaxCheckboxChecked: false
        }, () => {

          if (this.state.isAddrCheckboxActive) {
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.MIN_AMPLITUDE,
              data: this.state.ascAddrcMinAmplitudePageMap.get(this.state.activePage - 1)
            }]);
          }
          else if (this.state.isAscCheckboxActive) {
            // Order by y value depending on the ordering selected by the user
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.MIN_AMPLITUDE,
              data: this.state.ascMinAmplitudePageMap.get(this.state.activePage - 1)
            }]);
          }
          else if (this.state.isDescCheckboxActive) {
            // Order by y value depending on the ordering selected by the user
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.MIN_AMPLITUDE,
              data: this.state.descMinAmplitudePageMap.get(this.state.activePage - 1)
            }]);
          }

          // Change the title of the chart
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            title: {
              text: Strings.MIN_AMPLITUDE,
              align: "center"
            },
            yaxis: {
              min: 0,
              max: 2200,
              labels: {
                formatter: function (val) {
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }],
          });

          // And save that this is the active chart now
          this.setState({ activeChart: Constants.MIN_AMPLITUDE_ID });

        });
      }
    }
    else if (this.state.graphType === "noise") {
      if (value === Constants.ACTUAL_ID) {
        this.setState({
          isActualCheckboxChecked: true,
          isMinCheckboxChecked: false,
          isMaxCheckboxChecked: false
        }, () => {

          if (this.state.isAddrCheckboxActive) {
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.NOISE,
              data: this.state.ascAddrcNoisePageMap.get(this.state.activePage - 1)
            }]);
          }
          else if (this.state.isAscCheckboxActive) {
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.NOISE,
              data: this.state.ascNoisePageMap.get(this.state.activePage - 1)
            }]);
          }
          else if (this.state.isDescCheckboxActive) {
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.NOISE,
              data: this.state.descNoisePageMap.get(this.state.activePage - 1)
            }]);
          }

          // Change the title of the chart
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            title: {
              text: Strings.NOISE,
              align: "center"
            },
            yaxis: {
              min: 0,
              max: Constants.NOISE_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPANoiseBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });

          // And save that this is the active chart now
          this.setState({ activeChart: Constants.NOISE_ID });

        });
      }
      else if (value === Constants.MIN_ID) {
        this.setState({
          isActualCheckboxChecked: false,
          isMinCheckboxChecked: true,
          isMaxCheckboxChecked: false
        }, () => {

          if (this.state.isAddrCheckboxActive) {
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.NOISE_MIN,
              data: this.state.ascAddrcMinNoisePageMap.get(this.state.activePage - 1)
            }]);
          }
          else if (this.state.isAscCheckboxActive) {
            // Order by y value depending on the ordering selected by the user
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.NOISE_MIN,
              data: this.state.ascMinNoisePageMap.get(this.state.activePage - 1)
            }]);
          }
          else if (this.state.isDescCheckboxActive) {
            // Order by y value depending on the ordering selected by the user
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.NOISE_MIN,
              data: this.state.descMinNoisePageMap.get(this.state.activePage - 1)
            }]);
          }

          // Change the title of the chart
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            title: {
              text: Strings.NOISE_MIN,
              align: "center"
            },
            yaxis: {
              min: 0,
              max: Constants.NOISE_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPANoiseBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });

          // And save that this is the active chart now
          this.setState({ activeChart: Constants.MIN_NOISE_ID });

        });
      }
      else if (value === Constants.MAX_ID) {
        this.setState({
          isActualCheckboxChecked: false,
          isMinCheckboxChecked: false,
          isMaxCheckboxChecked: true
        }, () => {

          if (this.state.isAddrCheckboxActive) {
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.NOISE_MAX,
              data: this.state.ascAddrcMaxNoisePageMap.get(this.state.activePage - 1)
            }]);
          }
          else if (this.state.isAscCheckboxActive) {
            // Order by y value depending on the ordering selected by the user
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.NOISE_MAX,
              data: this.state.ascMaxNoisePageMap.get(this.state.activePage - 1)
            }]);
          }
          else if (this.state.isDescCheckboxActive) {
            // Order by y value depending on the ordering selected by the user
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.NOISE_MAX,
              data: this.state.descMaxNoisePageMap.get(this.state.activePage - 1)
            }]);
          }

          // Change the title of the chart
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            title: {
              text: Strings.NOISE_MAX,
              align: "center"
            },
            yaxis: {
              min: 0,
              max: Constants.NOISE_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPANoiseBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });

          // And save that this is the active chart now
          this.setState({ activeChart: Constants.MAX_NOISE_ID });

        });
      }
    }
    else if (this.state.graphType === "jitter") {
      if (value === Constants.ACTUAL_ID) {
        this.setState({
          isActualCheckboxChecked: true,
          isMinCheckboxChecked: false,
          isMaxCheckboxChecked: false
        }, () => {

          if (this.state.isAddrCheckboxActive) {
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.JITTER,
              data: this.state.ascAddrcJitterPageMap.get(this.state.activePage - 1)
            }]);
          }
          else if (this.state.isAscCheckboxActive) {
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.JITTER,
              data: this.state.ascJitterPageMap.get(this.state.activePage - 1)
            }]);
          }
          else if (this.state.isDescCheckboxActive) {
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.JITTER,
              data: this.state.descJitterPageMap.get(this.state.activePage - 1)
            }]);
          }

          // Change the title of the chart
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            title: {
              text: Strings.JITTER,
              align: "center"
            },
            yaxis: {
              min: 0,
              max: Constants.JITTER_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(2) + " " + Strings.MICROSSECOND;
                },
              },
              title: {
                text: Strings.MICROSSECOND_TITLE
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });

          // And save that this is the active chart now
          this.setState({ activeChart: Constants.JITTER_ID });

        });
      }
      else if (value === Constants.MIN_ID) {
        this.setState({
          isActualCheckboxChecked: false,
          isMinCheckboxChecked: true,
          isMaxCheckboxChecked: false
        }, () => {

          if (this.state.isAddrCheckboxActive) {
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.JITTER_MIN,
              data: this.state.ascAddrcMinJitterPageMap.get(this.state.activePage - 1)
            }]);
          }
          else if (this.state.isAscCheckboxActive) {
            // Order by y value depending on the ordering selected by the user
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.JITTER_MIN,
              data: this.state.ascMinJitterPageMap.get(this.state.activePage - 1)
            }]);
          }
          else if (this.state.isDescCheckboxActive) {
            // Order by y value depending on the ordering selected by the user
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.JITTER_MIN,
              data: this.state.descMinJitterPageMap.get(this.state.activePage - 1)
            }]);
          }

          // Change the title of the chart
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            title: {
              text: Strings.JITTER_MIN,
              align: "center"
            },
            yaxis: {
              min: 0,
              max: Constants.JITTER_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(2) + " " + Strings.MICROSSECOND;
                },
              },
              title: {
                text: Strings.MICROSSECOND_TITLE
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });

          // And save that this is the active chart now
          this.setState({ activeChart: Constants.MIN_JITTER_ID });

        });
      }
      else if (value === Constants.MAX_ID) {
        this.setState({
          isActualCheckboxChecked: false,
          isMinCheckboxChecked: false,
          isMaxCheckboxChecked: true
        }, () => {

          if (this.state.isAddrCheckboxActive) {
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.JITTER_MAX,
              data: this.state.ascAddrcMaxJitterPageMap.get(this.state.activePage - 1)
            }]);
          }
          else if (this.state.isAscCheckboxActive) {
            // Order by y value depending on the ordering selected by the user
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.JITTER_MAX,
              data: this.state.ascMaxJitterPageMap.get(this.state.activePage - 1)
            }]);
          }
          else if (this.state.isDescCheckboxActive) {
            // Order by y value depending on the ordering selected by the user
            ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
              name: Strings.JITTER_MAX,
              data: this.state.descMaxJitterPageMap.get(this.state.activePage - 1)
            }]);
          }

          // Change the title of the chart
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            title: {
              text: Strings.JITTER_MAX,
              align: "center"
            },
            yaxis: {
              min: 0,
              max: Constants.JITTER_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(2) + " " + Strings.MICROSSECOND;
                },
              },
              title: {
                text: Strings.MICROSSECOND_TITLE
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });

          // And save that this is the active chart now
          this.setState({ activeChart: Constants.MAX_JITTER_ID });

        });
      }
    }
    else if (this.state.graphType === "unbalance") {
      this.setState({
        isActualCheckboxChecked: true,
        isMinCheckboxChecked: false,
        isMaxCheckboxChecked: false
      }, () => {

        if (this.state.isAddrCheckboxActive) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.UNBALANCE,
            data: this.state.ascAddrcUnbalancePageMap.get(this.state.activePage - 1)
          }]);
        }
        else if (this.state.isAscCheckboxActive) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.UNBALANCE,
            data: this.state.ascUnbalancePageMap.get(this.state.activePage - 1)
          }]);
        }
        else if (this.state.isDescCheckboxActive) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.UNBALANCE,
            data: this.state.descUnbalancePageMap.get(this.state.activePage - 1)
          }]);
        }

        // Change the title of the chart
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
          title: {
            text: Strings.UNBALANCE,
            align: "center"
          },
          yaxis: {
            min: 0,
            max: Constants.UNBALANCE_MAX_Y_AXIS,
            labels: {
              formatter: function (val) {
                return val.toFixed(2) + " " + Strings.PORCENTAGEM;
              },
            },
            title: {
              text: Strings.UNBALANCE_PORCENT
            },
          },
          colors: [function ({ seriesIndex, dataPointIndex, w }) {
            const point = w.config.series[seriesIndex].data[dataPointIndex];
            const status = point.status;
            const hasWaveProblem = point.hasWaveProblem;
            return (UtilsInstance.getPAUnbalanceBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
          }]
        });

        // And save that this is the active chart now
        this.setState({ activeChart: Constants.UNBALANCE_ID });

      });
    }
  }

  // ---------------- Classification Options ----------------
  handleOrderCheckboxChange = (e, { value }) => {
    let devices = this.state.devices;
    if (value === Constants.CHECKBOX_ADDR_VAL) {
      this.setState({
        isAddrCheckboxActive: true,
        isAscCheckboxActive: false,
        isDescCheckboxActive: false,
      }, () => {
        // ---------------------- Amplitude ----------------------
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.AMPLITUDE,
            data: this.state.ascAddrcAmplitudePageMap.get(this.state.activePage - 1)
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: 2200,
              labels: {
                formatter: function (val) {
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPABarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        else if (this.state.activeChart === Constants.MIN_AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MIN_AMPLITUDE,
            data: this.state.ascAddrcMinAmplitudePageMap.get(this.state.activePage - 1)
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: 2200,
              labels: {
                formatter: function (val) {
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }],
          });
        }
        // ---------------------- Noise ----------------------
        else if (this.state.activeChart === Constants.NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE,
            data: this.state.ascAddrcNoisePageMap.get(this.state.activePage - 1)
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.NOISE_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPANoiseBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        else if (this.state.activeChart === Constants.MIN_NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE_MIN,
            data: this.state.ascAddrcMinNoisePageMap.get(this.state.activePage - 1)
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.NOISE_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPANoiseBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        else if (this.state.activeChart === Constants.MAX_NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE_MAX,
            data: this.state.ascAddrcMaxNoisePageMap.get(this.state.activePage - 1)
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.NOISE_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPANoiseBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        // ---------------------- Jitter ----------------------
        else if (this.state.activeChart === Constants.JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER,
            data: this.state.ascAddrcJitterPageMap.get(this.state.activePage - 1)
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.JITTER_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(2) + " " + Strings.MICROSSECOND;
                },
              },
              title: {
                text: Strings.MICROSSECOND_TITLE
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        else if (this.state.activeChart === Constants.MIN_JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER_MIN,
            data: this.state.ascAddrcMinJitterPageMap.get(this.state.activePage - 1)
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.JITTER_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(2) + " " + Strings.MICROSSECOND;
                },
              },
              title: {
                text: Strings.MICROSSECOND_TITLE
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        else if (this.state.activeChart === Constants.MAX_JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER_MAX,
            data: this.state.ascAddrcMaxJitterPageMap.get(this.state.activePage - 1)
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.JITTER_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(2) + " " + Strings.MICROSSECOND;
                },
              },
              title: {
                text: Strings.MICROSSECOND_TITLE
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        // ---------------------- Unbalance ----------------------
        else if (this.state.activeChart === Constants.UNBALANCE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.UNBALANCE,
            data: this.state.ascAddrcUnbalancePageMap.get(this.state.activePage - 1)
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.UNBALANCE_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(2) + " " + Strings.PORCENTAGEM;
                },
              },
              title: {
                text: Strings.UNBALANCE_PORCENT
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAUnbalanceBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
      });
    }
    else if (value === Constants.CHECKBOX_ASC_VAL) {
      this.setState({
        isAddrCheckboxActive: false,
        isAscCheckboxActive: true,
        isDescCheckboxActive: false,
      }, () => {
        // ---------------------- Amplitude ----------------------
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.AMPLITUDE,
            data: this.state.ascAmplitudePageMap.get((this.state.activePage - 1))
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: 2200,
              labels: {
                formatter: function (val) {
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }],
          });
        }
        else if (this.state.activeChart === Constants.MIN_AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MIN_AMPLITUDE,
            data: this.state.ascMinAmplitudePageMap.get((this.state.activePage - 1))
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: 2200,
              labels: {
                formatter: function (val) {
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }],
          });
        }
        // ---------------------- Noise ----------------------
        else if (this.state.activeChart === Constants.NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE,
            data: this.state.ascNoisePageMap.get((this.state.activePage - 1))
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.NOISE_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPANoiseBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        else if (this.state.activeChart === Constants.MIN_NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE_MIN,
            data: this.state.ascMinNoisePageMap.get((this.state.activePage - 1))
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.NOISE_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPANoiseBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        else if (this.state.activeChart === Constants.MAX_NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE_MAX,
            data: this.state.ascMaxNoisePageMap.get((this.state.activePage - 1))
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.NOISE_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPANoiseBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        // ---------------------- Jitter ----------------------
        else if (this.state.activeChart === Constants.JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER,
            data: this.state.ascJitterPageMap.get((this.state.activePage - 1))
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.JITTER_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(2) + " " + Strings.MICROSSECOND;
                },
              },
              title: {
                text: Strings.MICROSSECOND_TITLE
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        else if (this.state.activeChart === Constants.MIN_JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER_MIN,
            data: this.state.ascMinJitterPageMap.get((this.state.activePage - 1))
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.JITTER_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(2) + " " + Strings.MICROSSECOND;
                },
              },
              title: {
                text: Strings.MICROSSECOND_TITLE
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        else if (this.state.activeChart === Constants.MAX_JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER_MAX,
            data: this.state.ascMaxJitterPageMap.get((this.state.activePage - 1))
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.JITTER_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(2) + " " + Strings.MICROSSECOND;
                },
              },
              title: {
                text: Strings.MICROSSECOND_TITLE
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        // ---------------------- Unbalance ----------------------
        else if (this.state.activeChart === Constants.UNBALANCE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.UNBALANCE,
            data: this.state.ascUnbalancePageMap.get(this.state.activePage - 1)
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.UNBALANCE_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(2) + " " + Strings.PORCENTAGEM;
                },
              },
              title: {
                text: Strings.UNBALANCE_PORCENT
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAUnbalanceBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
      });
    }
    else if (value === Constants.CHECKBOX_DESC_VAL) {
      this.setState({
        isAddrCheckboxActive: false,
        isAscCheckboxActive: false,
        isDescCheckboxActive: true,
      }, () => {
        // ---------------------- Amplitude ----------------------
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.AMPLITUDE,
            data: this.state.descAmplitudePageMap.get((this.state.activePage - 1))
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: 2200,
              labels: {
                formatter: function (val) {
                  val = parseFloat(val.toFixed(0));
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }],
          });
        }
        else if (this.state.activeChart === Constants.MIN_AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MIN_AMPLITUDE,
            data: this.state.descMinAmplitudePageMap.get((this.state.activePage - 1))
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: 2200,
              labels: {
                formatter: function (val) {
                  val = parseFloat(val.toFixed(0));
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }],
          });
        }
        // ---------------------- Noise ----------------------
        else if (this.state.activeChart === Constants.NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE,
            data: this.state.descNoisePageMap.get((this.state.activePage - 1))
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.NOISE_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  val = parseFloat(val.toFixed(0));
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPANoiseBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        else if (this.state.activeChart === Constants.MIN_NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE_MIN,
            data: this.state.descMinNoisePageMap.get((this.state.activePage - 1))
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.NOISE_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  val = parseFloat(val.toFixed(0));
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPANoiseBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        else if (this.state.activeChart === Constants.MAX_NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE_MAX,
            data: this.state.descMaxNoisePageMap.get((this.state.activePage - 1))
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.NOISE_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  val = parseFloat(val.toFixed(0));
                  return val.toFixed(0) + " " + Strings.MILLIVOLT;
                },
              },
              title: {
                text: Strings.VOLTAGE_MV
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPANoiseBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        // ---------------------- Jitter ----------------------
        else if (this.state.activeChart === Constants.JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER,
            data: this.state.descJitterPageMap.get((this.state.activePage - 1))
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.JITTER_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(2) + " " + Strings.MICROSSECOND;
                },
              },
              title: {
                text: Strings.MICROSSECOND_TITLE
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        else if (this.state.activeChart === Constants.MIN_JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER_MIN,
            data: this.state.descMinJitterPageMap.get((this.state.activePage - 1))
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.JITTER_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(2) + " " + Strings.MICROSSECOND;
                },
              },
              title: {
                text: Strings.MICROSSECOND_TITLE
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        else if (this.state.activeChart === Constants.MAX_JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER_MAX,
            data: this.state.descMaxJitterPageMap.get((this.state.activePage - 1))
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.JITTER_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(2) + " " + Strings.MICROSSECOND;
                },
              },
              title: {
                text: Strings.MICROSSECOND_TITLE
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
        // ---------------------- Unbalance ----------------------
        else if (this.state.activeChart === Constants.UNBALANCE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.UNBALANCE,
            data: this.state.descUnbalancePageMap.get(this.state.activePage - 1)
          }]);
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
            yaxis: {
              min: 0,
              max: Constants.UNBALANCE_MAX_Y_AXIS,
              labels: {
                formatter: function (val) {
                  return val.toFixed(2) + " " + Strings.PORCENTAGEM;
                },
              },
              title: {
                text: Strings.UNBALANCE_PORCENT
              },
            },
            colors: [function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex];
              const status = point.status;
              const hasWaveProblem = point.hasWaveProblem;
              return (UtilsInstance.getPAUnbalanceBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
            }]
          });
        }
      });
    }
  }

  // ---------------- Pagination ----------------
  handlePageChange = (e, { activePage }) => {
    this.setState({ activePage: activePage }, () => {
      // Check which of the checkboxes are active first
      if (this.state.isAddrCheckboxActive) {
        // Then check which of the charts are active
        // -------------------------- AMPLITUDE --------------------------
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.AMPLITUDE,
            data: this.state.ascAddrcAmplitudePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsAmplitude();
        }
        else if (this.state.activeChart === Constants.MIN_AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MIN_AMPLITUDE,
            data: this.state.ascAddrcMinAmplitudePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsAmplitude();
        }
        // -------------------------- NOISE --------------------------
        else if (this.state.activeChart === Constants.NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE,
            data: this.state.ascAddrcNoisePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsNoise();
        }
        else if (this.state.activeChart === Constants.MIN_NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE_MIN,
            data: this.state.ascAddrcMinNoisePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsNoise();
        }
        else if (this.state.activeChart === Constants.MAX_NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE_MAX,
            data: this.state.ascAddrcMaxNoisePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsNoise();
        }
        // -------------------------- JITTER --------------------------
        else if (this.state.activeChart === Constants.JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER,
            data: this.state.ascAddrcJitterPageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsJitter();
        }
        else if (this.state.activeChart === Constants.MIN_JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER_MIN,
            data: this.state.ascAddrcMinJitterPageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsJitter();
        }
        else if (this.state.activeChart === Constants.MAX_JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER_MAX,
            data: this.state.ascAddrcMaxJitterPageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsJitter();
        }
        // -------------------------- UNBALANCE --------------------------
        else if (this.state.activeChart === Constants.UNBALANCE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.UNBALANCE,
            data: this.state.ascAddrcUnbalancePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsUnbalance();
        }
      }
      else if (this.state.isAscCheckboxActive) {
        // Then check which of the charts are active
        // -------------------------- AMPLITUDE --------------------------
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.AMPLITUDE,
            data: this.state.ascAmplitudePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsAmplitude();
        }
        else if (this.state.activeChart === Constants.MIN_AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MIN_AMPLITUDE,
            data: this.state.ascMinAmplitudePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsAmplitude();
        }
        // -------------------------- NOISE --------------------------
        else if (this.state.activeChart === Constants.NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE,
            data: this.state.ascNoisePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsNoise();
        }
        else if (this.state.activeChart === Constants.MIN_NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE_MIN,
            data: this.state.ascMinNoisePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsNoise();
        }
        else if (this.state.activeChart === Constants.MAX_NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE_MAX,
            data: this.state.ascMaxNoisePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsNoise();
        }
        // -------------------------- JITTER --------------------------
        else if (this.state.activeChart === Constants.JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER,
            data: this.state.ascJitterPageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsJitter();
        }
        else if (this.state.activeChart === Constants.MIN_JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER_MIN,
            data: this.state.ascMinJitterPageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsJitter();
        }
        else if (this.state.activeChart === Constants.MAX_JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER_MAX,
            data: this.state.ascMaxJitterPageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsJitter();
        }
        // -------------------------- UNBALANCE --------------------------
        else if (this.state.activeChart === Constants.UNBALANCE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.UNBALANCE,
            data: this.state.ascUnbalancePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsUnbalance();
        }
      }
      else if (this.state.isDescCheckboxActive) {
        // Then check which of the charts are active
        // -------------------------- AMPLITUDE --------------------------
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.AMPLITUDE,
            data: this.state.descAmplitudePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsAmplitude();
        }
        else if (this.state.activeChart === Constants.MIN_AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MIN_AMPLITUDE,
            data: this.state.descMinAmplitudePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsAmplitude();
        }
        // -------------------------- NOISE --------------------------
        else if (this.state.activeChart === Constants.NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE,
            data: this.state.descNoisePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsNoise();
        }
        else if (this.state.activeChart === Constants.MIN_NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE_MIN,
            data: this.state.descMinNoisePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsNoise();
        }
        else if (this.state.activeChart === Constants.MAX_NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE_MAX,
            data: this.state.descMaxNoisePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsNoise();
        }
        // -------------------------- JITTER --------------------------
        else if (this.state.activeChart === Constants.JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER,
            data: this.state.descJitterPageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsJitter();
        }
        else if (this.state.activeChart === Constants.MIN_JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER_MIN,
            data: this.state.descMinJitterPageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsJitter();
        }
        else if (this.state.activeChart === Constants.MAX_JITTER_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.JITTER_MAX,
            data: this.state.descMaxJitterPageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsJitter();
        }
        // -------------------------- UNBALANCE --------------------------
        else if (this.state.activeChart === Constants.UNBALANCE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.UNBALANCE,
            data: this.state.descUnbalancePageMap.get((this.state.activePage - 1))
          }]);
          this.updatePageChangeOptionsUnbalance();
        }
      }
    });
  }

  updatePageChangeOptionsAmplitude = () => {
    let devices = this.state.devices;
    ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
      yaxis: {
        min: 0,
        max: 2200,
        labels: {
          formatter: function (val) {
            return val.toFixed(0) + " " + Strings.MILLIVOLT;
          },
        },
        title: {
          text: Strings.VOLTAGE_MV
        },
      },
      colors: [function ({ value }) {
        return (UtilsInstance.getPABarGraphColorBasedOnValue(value, Constants, devices));
      }]
    });
  }

  updatePageChangeOptionsNoise = () => {
    let devices = this.state.devices;
    ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
      yaxis: {
        min: 0,
        max: Constants.NOISE_MAX_Y_AXIS,
        labels: {
          formatter: function (val) {
            return val.toFixed(0) + " " + Strings.MILLIVOLT;
          },
        },
        title: {
          text: Strings.VOLTAGE_MV
        },
      },
      colors: [function ({ value }) {
        return (UtilsInstance.getPANoiseBarGraphColorBasedOnValue(value, Constants, devices));
      }]
    });
  }

  updatePageChangeOptionsJitter = () => {
    let devices = this.state.devices;
    ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
      yaxis: {
        min: 0,
        max: Constants.JITTER_MAX_Y_AXIS,
        labels: {
          formatter: function (val) {
            return val.toFixed(2) + " " + Strings.MICROSSECOND;
          },
        },
        title: {
          text: Strings.MICROSSECOND_TITLE
        },
      },
      colors: [function ({ seriesIndex, dataPointIndex, w }) {
        const point = w.config.series[seriesIndex].data[dataPointIndex];
        const status = point.status;
        const hasWaveProblem = point.hasWaveProblem;
        return (UtilsInstance.getPAJitterBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
      }]
    });
  }

  updatePageChangeOptionsUnbalance = () => {
    let devices = this.state.devices;
    ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
      yaxis: {
        min: 0,
        max: Constants.UNBALANCE_MAX_Y_AXIS,
        labels: {
          formatter: function (val) {
            return val.toFixed(2) + " " + Strings.PORCENTAGEM;
          },
        },
        title: {
          text: Strings.UNBALANCE_PORCENT
        },
      },
      colors: [function ({ seriesIndex, dataPointIndex, w }) {
        const point = w.config.series[seriesIndex].data[dataPointIndex];
        const status = point.status;
        const hasWaveProblem = point.hasWaveProblem;
        return (UtilsInstance.getPAUnbalanceBarGraphColorBasedOnValue(status, Constants, devices, hasWaveProblem));
      }]
    });
  }

  /// ---------------- Error Messages -----------------------------
  retrieveWarnings = async () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "warnings/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
      .then(res => res.json())
      .then(data => {
        this.handleWarningMessages(data);
      });
  }

  handleWarningMessages = (errors) => {
    let errorMessages = [];

    if (errors.invertedPolarity || errors.mongoOFF || errors.picoNotFound || errors.scanFail) {
      // If at least one of the errors above ocurred, unhide the error message's container
      if (document.getElementById("message-list") !== undefined
        && document.getElementById("message-list") !== null) {
        document.getElementById("message-list").style.display = "block";
      }

      if (errors.invertedPolarity) {
        errorMessages.push(Strings.INVERTED_POLARITY);
      }

      if (errors.InitPicoNotFound) {
        errorMessages.push(Strings.INIT_PICO_NOT_FOUND);
      }

      if (errors.firstScanFail) {
        errorMessages.push(Strings.NO_ACTIVE_NETWORK);
      }

      if (errors.mongoOFF) {
        errorMessages.push(Strings.MONGO_OFF);
      }

      if (errors.picoNotFound) {
        errorMessages.push(Strings.PICO_NOT_FOUND);
      }

      if (errors.scanFail) {
        errorMessages.push(Strings.SCAN_FAIL_FOUND);
      }

      this.setState({ errorMessages: errorMessages });
    }
    else {

      if (document.getElementById("message-list") !== undefined
        && document.getElementById("message-list") !== null) {
        document.getElementById("message-list").style.display = "none";

      }

      this.setState({ errorMessages: [] });
    }
  }

  /// ---------------- Errors Accordion -----------------------------
  handleAccordionClick = (e, titleProps) => {
    const { index } = titleProps;
    const { accordionIndex } = this.state;
    const newIndex = accordionIndex === index ? -1 : index;

    this.setState({ accordionIndex: newIndex });
  };

  handleJitterAccordionClick = (e, titleProps) => {
    const { index } = titleProps;
    const { jitterAccordionIndex } = this.state;
    const newIndex = jitterAccordionIndex === index ? -1 : index;

    this.setState({ jitterAccordionIndex: newIndex });
  };

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
    this.retrieveWarnings();
    this.setState({ retrieveDataIntervalID: setInterval(this.retrieveData, 500) });
    this.setState({ warningsIntervalID: setInterval(this.retrieveWarnings, 5000) });
  }

  componentWillUnmount() {
    clearInterval(this.state.retrieveDataIntervalID);
    clearInterval(this.state.warningsIntervalID);
  }

  render() {

    return (
      <div style={screenStyle}>

        <Grid columns={2} doubling>

          <Grid.Row>

            <Grid.Column width={4}>

              <Segment>
                <Divider horizontal style={dividerStyle}>{Strings.GRAPH}</Divider>
                <Dropdown
                  disabled={this.state.isDropdownDisabled}
                  placeholder={Strings.BAR_GRAPH_TYPE_PLACEHOLDER}
                  fluid
                  selection
                  options={dropdownOptions}
                  onChange={this.onDropdownChange} />
              </Segment>

              <Segment>
                <Divider horizontal style={dividerStyle}>{Strings.VARIATION}</Divider>
                <Form style={formStyle}>
                  <Form.Field style={formFieldStyle} disabled={this.state.isActualCheckboxDisabled}>
                    <Checkbox
                      radio
                      label={Strings.CURRENT}
                      checked={this.state.isActualCheckboxChecked}
                      value={Constants.ACTUAL_ID}
                      onChange={this.onGraphVariationCheckboxChange} />
                  </Form.Field>

                  {!this.state.isMinCheckboxDisabled && (<Form.Field style={formFieldStyle}>
                    <Checkbox
                      radio
                      label={this.state.minCheckboxLabel}
                      checked={this.state.isMinCheckboxChecked}
                      value={Constants.MIN_ID}
                      onChange={this.onGraphVariationCheckboxChange} />
                  </Form.Field>)}

                  {!this.state.isMaxCheckboxDisabled && (<Form.Field style={formFieldStyle}>
                    <Checkbox
                      radio
                      label={this.state.maxCheckboxLabel}
                      checked={this.state.isMaxCheckboxChecked}
                      value={Constants.MAX_ID}
                      onChange={this.onGraphVariationCheckboxChange} />
                  </Form.Field>)}
                </Form>
              </Segment>

              <Segment id="order-seg">
                <Divider horizontal style={dividerStyle}>{Strings.ORDER_BY}</Divider>

                <Form style={formStyle}>
                  <Form.Field style={formFieldStyle} disabled={this.state.isaddrAscCheckboxDisabled}>
                    <Checkbox
                      id="amp-addr-checkbox"
                      radio
                      label={Strings.ADDRESS_ASC}
                      checked={this.state.isAddrCheckboxActive}
                      value={Constants.CHECKBOX_ADDR_VAL}
                      onChange={this.handleOrderCheckboxChange}
                    />
                  </Form.Field>
                  <Form.Field style={formFieldStyle} disabled={this.state.isVoltAscCheckboxDisabled}>
                    <Checkbox
                      id="amp-asc-checkbox"
                      radio
                      label={this.state.ascCheckboxLabel}
                      checked={this.state.isAscCheckboxActive}
                      value={Constants.CHECKBOX_ASC_VAL}
                      onChange={this.handleOrderCheckboxChange}
                    />
                  </Form.Field>
                  <Form.Field style={formFieldStyle} disabled={this.state.isVoltDescCheckboxDisabled}>
                    <Checkbox
                      id="amp-desc-checkbox"
                      radio
                      label={this.state.descCheckboxLabel}
                      checked={this.state.isDescCheckboxActive}
                      value={Constants.CHECKBOX_DESC_VAL}
                      onChange={this.handleOrderCheckboxChange}
                    />
                  </Form.Field>
                </Form>

              </Segment>

              <Accordion id="message-list" styled style={accordionStyle}>
                <Accordion.Title
                  style={accordionTitleStyle}
                  active={this.state.accordionIndex === 1}
                  index={1}
                  onClick={this.handleAccordionClick}>
                  <Icon name="exclamation triangle" />
                  {Strings.DETECTED_PROBLEMS}
                  <Icon name="dropdown" />
                </Accordion.Title>
                <Accordion.Content active={this.state.accordionIndex === 1}>
                  <div style={accordionListItemsStyle}>
                    <ul style={{ paddingLeft: 0 }}>
                      {this.state.errorMessages.map((message) => (
                        <li key={message}>{message}</li>
                      ))}
                    </ul>
                  </div>
                </Accordion.Content>
              </Accordion>

              <Accordion id="jitter-accordion" styled style={jitterAccordionStyle}>
                <Accordion.Title
                  style={jitterAccordionTitleStyle}
                  active={this.state.jitterAccordionIndex === 1}
                  index={1}
                  onClick={this.handleJitterAccordionClick}>
                  <Icon name="info circle" />{Strings.JITTER_MESSAGE_HEADER}<Icon name="dropdown" />
                </Accordion.Title>
                <Accordion.Content active={this.state.jitterAccordionIndex === 1}>
                  <p style={jitterAccordionTextStyle}>
                    {Strings.JITTER_MESSAGE_1}
                  </p>
                </Accordion.Content>
              </Accordion>

            </Grid.Column>

            <Grid.Column width={12}>
              <Segment>

                <Chart
                  id="amp-chart"
                  options={this.state.options}
                  series={[{ name: Strings.AMPLITUDE, data: [] }]}
                  height={UtilsInstance.adjustChartHeight()}
                  type="bar" />

                <Pagination
                  style={paginationStyle}
                  id="pagination"
                  activePage={this.state.activePage}
                  onPageChange={this.handlePageChange}
                  totalPages={this.state.numOfPages} />

              </Segment>

            </Grid.Column>

          </Grid.Row>
        </Grid>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  channel: state.activeMenuItem.channel
});

const screenStyle = {
  margin: "4vh 2vw",
  textAlign: "center",
};

const formStyle = {
  marginTop: "-1vh",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "-2vh"
};

const formFieldStyle = {
  marginBottom: "-1vh"
};

const paginationStyle = {
  visibility: "hidden"
};

const dividerStyle = {
  marginTop: "-0.2vh"
};

const accordionStyle = {
  color: "#9F3A38",
  backgroundColor: "#FFF6F6",
  display: "none",
  marginBottom: "2vh",
};

const accordionTitleStyle = {
  color: "#9F3A38",
};

const accordionListItemsStyle = {
  textAlign: "left",
  listStylePosition: "inside",
};

const jitterAccordionStyle = {
  backgroundColor: "#F8FFFF",
  display: "none",
  marginBottom: "2vh",
};

const jitterAccordionTitleStyle = {
  color: "#0E566C",
};

const jitterAccordionTextStyle = {
  textAlign: "justify",
  color: "#0E566C"
};

export default connect(mapStateToProps)(withRouter(BarGraph));
